import { SvgIcon, useTheme } from "@mui/material";

const ForwardIcon = ({ color, fontSize }: any) => {

    const theme = useTheme();

    return (
        <SvgIcon sx={{ fontSize: fontSize || 32, mt: .3, mx: 1 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M13.25 23L11.75 21.5L17.249 16.001L11.75 10.5L13.25 9L20.25 16.0021L13.25 23Z" fill={color || theme.palette.secondary.contrastText} />
            </svg>
        </SvgIcon>
    );

};

export default ForwardIcon;